import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RoundActionIconButton } from "../components/Buttons/ActionIconButton/RoundActionIconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import { ChatSettingsDialog } from "./ChatSettingsDialog";
import { useState } from "react";
export function ChatSettingsButton({ textColor, systemPrompt, setSystemPrompt, temperature, setTemperature, model, setModel, hasSysPromptPermission, }) {
    const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
    const handleCloseSettingsDialog = () => {
        setOpenSettingsDialog(false);
    };
    const handleAcceptSettingsDialog = (systPrompt, temperature, model) => {
        setOpenSettingsDialog(false);
        if (hasSysPromptPermission) {
            setSystemPrompt(systPrompt);
        }
        setTemperature(temperature);
        setModel(model);
    };
    return (_jsxs(_Fragment, { children: [_jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Settings", onClick: () => {
                    setOpenSettingsDialog(true);
                }, baseColor: textColor }, { children: _jsx(SettingsIcon, { fontSize: "small" }) })), _jsx(ChatSettingsDialog, { open: openSettingsDialog, handleClose: handleCloseSettingsDialog, handleAccept: handleAcceptSettingsDialog, hasSysPromptPermission: hasSysPromptPermission, defaultSystPrompt: systemPrompt, defaultTemperature: temperature, defaultModel: model })] }));
}
